import { Suspense, lazy, useRef, type ReactNode } from "react";

/**
 * E-BUNDLE-17 — Ladeschranke vor dem mobilen Nav-Drawer.
 *
 * `MobileNavDrawer` rendert bei `open === false` nichts ("no offscreen DOM"),
 * hing aber mit Focus-Trap, Scroll-Lock und Escape-Behandlung fest im
 * Startpfad — rund 1,6 kB generierter Code fuer ein Panel, das der erste Paint
 * nie zeigt. Die Schranke laedt das Modul erst, wenn der Drawer zum ersten Mal
 * geoeffnet wird.
 *
 * Einmal geladen bleibt der Drawer montiert: `armed` faellt nie wieder auf
 * `false` zurueck. Damit behaelt die Komponente ihren eigenen Uebergang von
 * `open === true` nach `open === false` und stellt den Fokus so wieder her wie
 * vorher. Die Komponente selbst ist nicht angefasst.
 */
const MobileNavDrawer = lazy(async () => {
  const mod = await import("./MobileNavDrawer.js");
  return { default: mod.MobileNavDrawer };
});

export interface MobileNavDrawerGateProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly ariaLabel: string;
  readonly children: ReactNode;
}

export function MobileNavDrawerGate({
  open,
  onClose,
  ariaLabel,
  children,
}: MobileNavDrawerGateProps): ReactNode {
  const armed = useRef(false);
  if (open) armed.current = true;
  if (!armed.current) return null;
  return (
    <Suspense fallback={null}>
      <MobileNavDrawer open={open} onClose={onClose} ariaLabel={ariaLabel}>
        {children}
      </MobileNavDrawer>
    </Suspense>
  );
}
